module.exports = __webpack_public_path__ + "static/iot-32448d3ded9576f64048717e2276d9c6.png";